import React from 'react';
import './pageNotFound.css';
import strings from '../utils/property-file/pageNotFound.json';
import ServerDown from '../Asset/Images/ServerDown.svg';
import Ripple from '../component/button/ripple';
import { useNavigate } from 'react-router-dom';
import constants from "../utils/constants";

export default function PageNotFound() {
    const nav = useNavigate();
    return (
        <div className="error-page">
            <div className="animation-effet">
                <div className='white-filter'></div>
                <img src={ServerDown} alt="" className='image-page-not-found' />
            </div>
            <div className="page-not-found-heading">
                <h1>{strings.PageNotFound}</h1>
                <center>
                    <button
                        type="submit"
                        className="btn btn-primary homepage-btn"
                        onClick={() => {
                            nav(constants.navigationLink.backPage)
                        }}
                    >
                        <Ripple duration={1000} />
                        {strings.btn}
                    </button>
                </center>
            </div>
        </div>
    )
}
